export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Article.json?hash=644f5c16ac4422f96e41d127cece3cc2";